import type { DoorOffer } from '../../../core/floor';
import { hudState, REWARD_TEXT } from '../state';
import { useHotkeys } from '../useHotkeys';

export function Doors({ doors }: { doors: DoorOffer[] }) {
  const choose = (i: number): void => { if (i < doors.length) hudState.send({ type: 'chooseDoor', index: i }); };
  useHotkeys(true, choose);
  // Salle générée : les portes sont sur les sorties ; le panneau devient une barre compacte qui laisse voir la carte.
  if (doors.some((d) => d.pos)) {
    return (
      <div class="panel doors-bar" role="group" aria-label="Portes">
        <p class="doors-hint">Rejoignez une sortie, ou choisissez :</p>
        <div class="doors-choices">
          {doors.map((d, i) => (
            <button key={`${i}-${d.reward}`} class={`door-chip door-${d.reward}`} onMouseDown={(e) => e.preventDefault()} title={REWARD_TEXT[d.reward].detail} aria-label={`Porte ${i + 1} : ${REWARD_TEXT[d.reward].title}`} onClick={() => choose(i)}>
              <span class="card-key">{i + 1}</span>{REWARD_TEXT[d.reward].title}
            </button>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div class="panel doors-panel">
      <h2>Choisissez une porte</h2>
      <div class="cards">
        {doors.map((d, i) => (
          <button key={`${i}-${d.reward}`} class="card" onMouseDown={(e) => e.preventDefault()} aria-label={`Porte ${i + 1} : ${REWARD_TEXT[d.reward].title}`} onClick={() => choose(i)}>
            <span class="card-key">{i + 1}</span>
            <b>{REWARD_TEXT[d.reward].title}</b>
            <p>{REWARD_TEXT[d.reward].detail}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
